<template>
  <div class="info-container">
    <AppNavbar
      class="nav-bar"
      :title="title"
      :options="options"
      :zIndex="1"
    ></AppNavbar>
    <img
      class="bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/15caec18fe7d0db9b84030407bcf0079.png"
      alt=""
    />
    <div>
      <div class="title">
        <div class="hello">Hello！</div>
        <div
          class="nickname"
          :style="{ opacity: userInfo.user && userInfo.user.truename ? 1 : 0 }"
          >{{ userInfo.user && userInfo.user.truename }}</div
        >
      </div>
      <div class="desc">欢迎使用懒人定制饭盒</div>
      <div class="user-form">
        <div class="tip">
          我们将根据您的身体情况，为您匹配您的饭盒方案，请先确认以下基本信息：
        </div>
        <div class="user-title">您的体重是？</div>
        <CsRuler
          class="cs-rules"
          @change="bindWeightChange"
          :NowNum="weightData.defaultNum"
          :maxNum="weightData.maxNum"
          :minNum="weightData.minNum"
          unit="kg"
        ></CsRuler>
        <div class="user-title">您的身高是？</div>
        <CsRuler
          class="cs-rules"
          @change="bindHeightChange"
          :NowNum="heightData.defaultNum"
          :maxNum="heightData.maxNum"
          :minNum="heightData.minNum"
          unit="cm"
        ></CsRuler>
        <div class="btn" @click="createPlan">一键生成饭盒方案</div>
      </div>
    </div>
    <MyToast
      :options="toastOptions"
      v-model="showToast"
      @confirm="bindConfirm"
    ></MyToast>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import MyToast from './components/toast.vue'
import CsRuler from '@/components/app/ruler/ruler.vue'
export default {
  components: {
    AppNavbar,
    CsRuler,
    MyToast
  },
  data() {
    return {
      title: '方案定制',
      options: {
        barBackgroundColor: 'transparent',
        color: '#fff'
      },
      curGender: 0,
      toastOptions: {},
      showToast: false,
      rulerNum: 60, // 刻度尺当前值
      defaultNum: 60, //刻度尺默认值
      minNum: 20,
      maxNum: 200,
      userInfo: null,
      weightData: {
        title: '您的体重是？',
        rulerNum: 55, // 刻度尺当前值
        defaultNum: 55, //刻度尺默认值
        minNum: 20,
        maxNum: 200
      },
      heightData: {
        title: '您的身高是？',
        rulerNum: 160, // 刻度尺当前值
        defaultNum: 160, //刻度尺默认值
        minNum: 100,
        maxNum: 250
      }
    }
  },
  created() {
    this.getUserInfo()
  },
  mounted() {
    document.addEventListener('scroll', this.bindScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.bindScroll)
  },
  methods: {
    getUserInfo() {
      this.$http
        .getBaseApp('member/todayDiet/index', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userInfo = res.data
            let weight = this.initNum(
              parseFloat(res.data.weight),
              this.weightData
            )
            this.weightData.rulerNum = weight
            this.weightData.defaultNum = weight
            let height = this.initNum(
              parseFloat(res.data.height),
              this.heightData
            )
            this.heightData.rulerNum = height
            this.heightData.defaultNum = height
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    initNum(num, data) {
      if (num <= 0) {
        return data.defaultNum
      }
      let res = data.defaultNum
      if (num < data.minNum) {
        res = data.minNum
      } else if (num > data.maxNum) {
        res = data.maxNum
      } else {
        res = num
      }
      return res
    },
    bindScroll(e) {
      let scrollTop = e.target.documentElement.scrollTop
      if (scrollTop <= 20) {
        this.options = {
          barBackgroundColor: 'transparent',
          color: '#fff'
        }
      } else {
        this.options = {
          barBackgroundColor: '#fff'
        }
      }
    },
    createPlan() {
      this.crateDrinkPlan()
    },
    crateDrinkPlan() {
      let params = {
        weight: this.weightData.rulerNum,
        height: this.heightData.rulerNum
      }
      this.$http
        .postBaseApp('member/todayDiet/lunchBoxScheme', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (this.$route.query.change) {
              this.toastOptions = {
                title: '修改成功！',
                message: ''
              }
              this.showToast = true
            } else {
              this.$router.replace({
                path: '/eating-today/index',
                query: {
                  type: 'create'
                }
              })
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    bindConfirm() {
      this.$router.go(-1)
    },
    bindWeightChange(val) {
      this.weightData.rulerNum = val
    },
    bindHeightChange(val) {
      this.heightData.rulerNum = val
    }
  }
}
</script>
<style lang="scss" scoped>
.info-container {
  position: relative;
  min-height: 100vh;
  background: #ffffff;
  overflow: hidden;
  z-index: 0;
  padding: 0px 20px;
  box-sizing: border-box;

  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    object-fit: contain;
    z-index: -1;
  }

  .title {
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 46px;
    margin-top: 89px;
    margin-bottom: 5px;
  }

  .hello {
    margin-top: 89px;
  }

  .nickname {
    min-height: 46px;
    opacity: 0;
    transition: all 0.3s ease;
  }

  .desc {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 28px;
    margin-bottom: 26px;
  }

  .user-form {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;

    .tip {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 30px;
    }

    .user-title {
      position: relative;
      padding-left: 9px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
      margin-bottom: 24px;
    }

    .user-title::after {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0%, -50%);
      width: 3px;
      height: 18px;
      background: #6b24ff;
    }

    .gender {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 47px;

      .gender-item {
        text-align: center;
        width: 138px;
        height: 50px;
        border-radius: 6px;
        border: 2px solid rgba(107, 36, 255, 0.3);
        line-height: 50px;
        color: rgba(98, 54, 255, 0.4);
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;

        .iconfont {
          margin-right: 10px;
          font-size: 18px;
        }
      }

      .gender-item-active {
        border: 2px solid rgba(98, 54, 255, 1);
        color: rgba(98, 54, 255, 1);
      }
    }

    .cs-rules {
      margin-bottom: 10px;
    }

    .btn {
      width: 295px;
      height: 42px;
      background: #6236ff;
      border-radius: 12px;
      margin: 0 auto;
      text-align: center;
      line-height: 42px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 42px;
      margin-bottom: 40px;
    }
  }
}
</style>
